import { render, staticRenderFns } from "./PageRenge.vue?vue&type=template&id=e7a2173c&"
import script from "./PageRenge.vue?vue&type=script&lang=ts&"
export * from "./PageRenge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports